import * as Yup from 'yup';
import { useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { api } from 'src/Api';
import { postJson } from 'src/utils/clutchApi';
import { RESET_EMAIL_KEY, RESET_TOKEN_KEY } from 'src/utils/clutchAdminAuth';

export default function ForgotForm() {
  const navigate = useNavigate();
  const [alert, setalert] = useState({ visible: false, message: '', color: 'success' });
  const [loading, setloading] = useState(false);

  const ForgotSchema = Yup.object().shape({
    email: Yup.string().email('Enter a valid email address').required('Email address is required')
  });

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: ForgotSchema,
    onSubmit: () => {
      sendResetCode();
    }
  });

  const { errors, values, touched, handleSubmit, getFieldProps } = formik;

  async function sendResetCode() {
    setloading(true);
    setalert({ visible: false, message: '', color: 'success' });

    try {
      const result = await postJson(api.passwordForgot, { email: values.email });
      localStorage.setItem(RESET_EMAIL_KEY, values.email);
      sessionStorage.removeItem(RESET_TOKEN_KEY);
      setalert({ visible: true, message: result.message, color: 'success' });
      setTimeout(() => {
        navigate('/otpVerification', { replace: true });
      }, 500);
    } catch (error) {
      setalert({ visible: true, message: error.message, color: 'error' });
    } finally {
      setloading(false);
    }
  }

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField
            required
            fullWidth
            type="email"
            label="Email address"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />

          {alert.visible && (
            <Alert
              onClose={() => {
                setalert({ visible: false, message: '', color: 'success' });
              }}
              severity={alert.color}
            >
              {alert.message}
            </Alert>
          )}

          <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={loading}>
            Send reset code
          </LoadingButton>

          <LoadingButton
            fullWidth
            size="large"
            variant="outlined"
            onClick={() => {
              navigate('/login', { replace: true });
            }}
          >
            Back to login
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
